// src/api/categoriesApi.js

// // Import the categories data (same as in your data.js)
// import { categories } from '../data/categories';

// // Simulate a network delay (like a real API)
// const sleep = (ms) => {
//   return new Promise(resolve => setTimeout(resolve, ms));
// };

// /**
//  * Fetches categories data (mocked until backend is ready)
//  * @returns {Promise<Array>} - Resolves with categories array
//  */
// export const fetchCategories = async () => {
//   try {
//     await sleep(800); // Simulate network latency (0.8 seconds)
//     return categories;
//   } catch (error) {
//     console.error('API Error: Failed to fetch categories', error);
//     throw error;
//   }
// };

// // src/api/categoriesApi.js

// const API_URL = `${process.env.REACT_APP_API_BASE_URL}/products`;

// // Cache object
// let cache = {
//   data: null,
//   timestamp: null,
//   ttl: 5 * 60 * 1000 // 5 minutes in milliseconds
// };

// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// /**
//  * Fetches categories data from real API with caching
//  * @returns {Promise<Array>} - Resolves with API response
//  */
// export const fetchCategories = async () => {
//   try {
//     // Check if cache is valid
//     const now = Date.now();
//     if (cache.data && cache.timestamp && (now - cache.timestamp) < cache.ttl) {
//       console.log('Using cached categories data');
//       return cache.data;
//     }

//     // Simulate realistic network delay only on actual fetch
//     await sleep(800);

//     const response = await fetch(API_URL);

//     if (!response.ok) {
//       if (cache.data) {
//         console.warn('API failed, using stale cache');
//         return cache.data;
//       }
//       throw new Error(`API Error: ${response.status} ${response.statusText}`);
//     }

//     const data = await response.json();

//     if (!Array.isArray(data)) {
//       throw new Error('Invalid data format received from API');
//     }

//     // Update cache
//     cache.data = data;
//     cache.timestamp = Date.now();

//     console.log('Fetched and cached fresh categories data');
//     return data;
//   } catch (error) {
//     console.error('API Error: Failed to fetch categories', error);

//     // If offline or API fails, serve from cache if available
//     if (cache.data) {
//       console.warn('Network error, using cached data');
//       return cache.data;
//     }

//     if (error.message.includes('Failed to fetch')) {
//       throw new Error('Network error: Unable to connect to server. Please check your internet connection.');
//     }

//     throw error;
//   }
// };

// /**
//  * Manually clear cache (e.g., when you want fresh data)
//  */
// export const clearCategoriesCache = () => {
//   cache.data = null;
//   cache.timestamp = null;
//   console.log('🗑️ Categories cache cleared');
// };

import { fetchProductCategoriesDev } from "./productApi";

/**
 * Categories for the navbar's WOMEN menu.
 *
 * Since 2026-10-20 this is the `women` half of the Commerce API's
 * `/product_category` ({ women, men }), read through productApi's cached,
 * normalised fetch — one request serves the navbar and the Women/Men pages.
 * The old Cloud Function `product_category` returned one flat list, which
 * this module fetched itself behind a 5-minute cache that also served stale
 * data on error; both went with it.
 *
 * @returns {Promise<Array<{ category: string, index: number|null, total_count: number, subcategories: Array<{ product_type_name: string, product_count: number, image_url: string|null }> }>>}
 */
export const fetchCategories = async () => {
  const { women } = await fetchProductCategoriesDev();
  return Array.isArray(women) ? women : [];
};
